import { render, staticRenderFns } from "./TollEdit.vue?vue&type=template&id=2b94b11a"
import script from "./TollEdit.vue?vue&type=script&lang=js"
export * from "./TollEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports